import { render, staticRenderFns } from "./dictionaryManageEdit.vue?vue&type=template&id=7887b654&scoped=true&"
import script from "./dictionaryManageEdit.vue?vue&type=script&lang=js&"
export * from "./dictionaryManageEdit.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryManageEdit.vue?vue&type=style&index=0&id=7887b654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7887b654",
  null
  
)

export default component.exports